import { PotHeaderCard } from './PotHeaderCard';
import { PotTimelineCard } from './PotTimelineCard';
import { PotFinancialBreakdownCard } from './PotFinancialBreakdownCard';
import { PotStatusDeadlinesCard } from './PotStatusDeadlinesCard';
import { PotWorkersCard } from './PotWorkersCard';
import { PotDeductionsCard } from './PotDeductionsCard';
import type { PotDetailsDisplayModel } from '../../types/potDetails.types';

interface PotOverviewContentProps {
  potDetails: PotDetailsDisplayModel;
  wasLate?: boolean;
  submitDeadlineExtendedUntil?: string | null;
  onWorkerClick?: (userId: string) => void;
  onDeductionClick?: (deductionId: string) => void;
}

export function PotOverviewContent({
  potDetails,
  wasLate,
  submitDeadlineExtendedUntil,
  onWorkerClick,
  onDeductionClick,
}: PotOverviewContentProps) {
  return (
    <div className="flex flex-col gap-4">
      <PotHeaderCard
        potDetails={potDetails}
        wasLate={wasLate}
        submitDeadlineExtendedUntil={submitDeadlineExtendedUntil}
      />

      <PotTimelineCard approvals={potDetails.approvals} />

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        {potDetails.financials && (
          <PotFinancialBreakdownCard
            financials={potDetails.financials}
            fixedRateWorkers={potDetails.fixedRateWorkers}
          />
        )}
        <PotStatusDeadlinesCard
          deadlines={potDetails.deadlines}
          autoSubmit={potDetails.autoSubmit}
          className={potDetails.financials ? undefined : 'md:col-span-2'}
        />
      </div>

      {(() => {
        const hasWorkers =
          potDetails.gangMemberSplits.length > 0 ||
          potDetails.fixedRateWorkers.length > 0;
        const hasDeductions = potDetails.deductions.length > 0;
        const bothShow = hasWorkers && hasDeductions;

        if (!hasWorkers && !hasDeductions) return null;

        return (
          <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
            {hasWorkers && (
              <PotWorkersCard
                gangMemberSplits={potDetails.gangMemberSplits}
                fixedRateWorkers={potDetails.fixedRateWorkers}
                onWorkerClick={onWorkerClick}
                className={bothShow ? undefined : 'md:col-span-2'}
              />
            )}
            {hasDeductions && (
              <PotDeductionsCard
                deductions={potDetails.deductions}
                onDeductionClick={onDeductionClick}
                className={bothShow ? undefined : 'md:col-span-2'}
              />
            )}
          </div>
        );
      })()}
    </div>
  );
}
